<template>
  <v-app>
    <dashboard-core-app-bar v-model="expandOnHover" />

    <dashboard-core-drawer :expand-on-hover.sync="expandOnHover" />

    <dashboard-core-view />

    <dashboard-core-settings v-model="expandOnHover" />
    <group-bulk-sms-composer />
    <group-bulk-email-composer />
    <group-bulk-ivr-composer />
  </v-app>
</template>

<script>
  /* eslint-disable */
import UserHelper from '../../utils/user-helper';

export default {
  name: "PosAdminModule",
  components: {
    DashboardCoreAppBar: () => import("./components/pos-app-bar/pos-app-bar.vue"),
    DashboardCoreDrawer: () => import("./components/pos-drawer/pos-drawer.vue"),
    DashboardCoreSettings: () => import("../../views/dashboard/components/core/View.vue"),
    DashboardCoreView: () => import("../../views/dashboard/components/core/Settings.vue"),
    GroupBulkSmsComposer: () => import(
        "../private-module/components/group-bulk-sms-composer/group-bulk-sms-composer.vue"
      ),
    GroupBulkEmailComposer: () => import(
        "../private-module/components/group-bulk-email-composer/group-bulk-email-composer.vue"
      ),
    GroupBulkIvrComposer: () => import(
        "../private-module/components/group-bulk-ivr-composer/group-bulk-ivr-composer.vue"
      ),
  },
  data: () => ({
    expandOnHover: false,
  }),
  computed: {
    hideAppBar() {
      return this.$route.meta.hideAppBar !== true;
    },
    hideDrawer() {
      return this.$route.meta.hideDrawer !== true;
    },
  },
  created () {
    UserHelper.syncUserInfo();
  }
};
</script>
